export const API_URL = import.meta.env.VITE_API_URL;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_API_KEY;
